<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">

      <template slot="left" >
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-tools</v-icon>{{$t('profile.tool.toolheadssub')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <ToolHeadSubForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import ToolHeadSubForm from '../../components/toolheadsub/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'ToolHeadSub';

const { mapFields } = createHelpers({
  getterType: 'toolheadsub/getField',
  mutationType: 'toolheadsub/updateField'
});

export default {
  name: 'ToolHeadSubCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    ToolHeadSubForm
  },
  data() {
    return {
      item: {
        'toolHead' : this.$route.params.parent
      }
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('toolheadsub', ['create', 'reset'])
  }
};
</script>
